<template>
  <section class="account">
    <div class="container">
      <h1 class="title">Become a vendor</h1>
      <div class="row">
        <div class="col">
          <loading v-if="loading" class="white-bg shadow-card" />
          <div
            class="card shadow-card"
            data-v-step="becomeVendorContainer"
            v-if="!loading && user"
          >
            <div class="card-body">
              <div class="form-group">
                <label>Vendor Name</label>
                <input type="text" v-model="vendor.name" class="form-control" />
              </div>
              <div class="form-group">
                <label>Vendor Email</label>
                <input
                  type="email"
                  v-model="vendor.email"
                  class="form-control"
                />
              </div>
              <div class="form-group">
                <label>Vendor Website</label>
                <input
                  type="text"
                  v-model="vendor.website"
                  class="form-control"
                />
              </div>
              <div class="form-group">
                <label>Vendor Phone</label>
                <input
                  type="text"
                  v-model="vendor.phone"
                  :key="resetCount"
                  v-cleave="cleave.phone"
                  class="form-control"
                />
              </div>
              <div class="d-flex align-items-center justify-content-center">
                <button
                  @click="becomeVendor"
                  :disabled="saving"
                  class="btn btn-primary btn-block btn-300"
                >
                  <span v-if="!saving">Send Request</span>
                  <span
                    class="spinner-border spinner-border-sm"
                    v-if="saving"
                    role="status"
                    aria-hidden="true"
                  ></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState } from "vuex";
import Auth from "@/auth";

export default {
  name: "Account",
  data() {
    return {
      vendor: {
        name: "",
        email: "",
        phone: "",
        website: "",
      },
      cleave: {
        phone: { blocks: [3, 3, 8], delimiter: "-", numericOnly: true },
      },
      resetCount: 0,
    };
  },
  computed: {
    ...mapState(["saving", "loading", "users"]),
    userData: function () {
      return Auth.user.get();
    },
    user: function () {
      return this.users.user;
    },
  },
  mounted() {
    this.$store.commit("SET_LOADING_STATE", false, { root: true });
  },
  methods: {
    becomeVendor: function () {
      const errors = [];

      if (this.vendor.name == "") {
        errors.push("Name is required");
      }
      if (this.vendor.email == "") {
        errors.push("Email is required");
      }

      if (this.vendor.website == "") {
        errors.push("Website is required");
      }

      if (this.vendor.phone == "") {
        errors.push("Phone is required");
      }

      if (this.vendor.phone !== "" && this.vendor.phone.length < 12) {
        errors.push("The phone must be at least 10 digits.");
      }

      if (errors.length) {
        let msg = errors.join("<br>");
        this.$store.dispatch(
          "setError",
          { message: msg, title: "Validation Errors" },
          { root: true }
        );
        return;
      }

      this.$store
        .dispatch("users/becomeVendor", this.vendor)
        .then((success) => {
          if (success) {
            this.vendor = {
              name: "",
              email: "",
              phone: "",
              website: "",
            };
            this.resetCount++;
          }
        });
    },
  },
};
</script>
